import React, { useState } from "react";
import {
    View,
    Alert,
    TouchableOpacity,
    Image,
    ActivityIndicator,
    StatusBar,
    Platform,
    Text,
    Pressable,
    Linking
} from "react-native";
import * as ImageManipulator from 'expo-image-manipulator';
import * as ImagePicker from "expo-image-picker";
import { useNavigation } from "@react-navigation/native";
import styles from "../../../styles/profileStyle";
import {
    getImageURL,
    getS3URL,
    getUserData,
    putImageInS3URL,
    updateData,
    updateDataImage,
} from "../../../../../services/Profile/profileService";
import { PROFILE_ROUTES } from "../../../../../navigation/routes";
import TopIconView from "../../../../Auth/components/TopIconView";
import TextView from "../../../../../components/CustomComponent/TextView";
import BottomView from "../../../../../components/GlobalComponents/BottomView";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import OnBoardingIcons from "../../../../../assets/Icons/OnBoardingIcons";
import OnboardingUploadModal from "../../../../../modal/OnBoardingModal/OnboardingUploadModal";
import { handleBackButton } from "../../../components/BackButtonAlert";
import { useBackButtonHandler } from "../../../hooks/useBackHandler";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import { SafeAreaView } from "react-native-safe-area-context";

const UploadProfie = () => {
    // const navigation = useNavigation();
    const navigation = useNavigation();
    useBackButtonHandler(handleBackButton, [navigation]);

    const [modalVisible, setModalVisible] = useState(false);
    const [image, setSelectedImage] = useState({});
    const [imageArrays, setimageArrays] = useState<any[]>([]);
    const [uriArray, setUriArray] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [teg, setTeg] = useState(false)


    const handleUploadGallery = async () => {
        try {
            const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()

            if (permissionResult.granted === false) {
                return;
            }

            let result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ImagePicker.MediaTypeOptions.Images,
                aspect: [4, 3],
                quality: 0.3,
                allowsEditing: false,
                allowsMultipleSelection: true,
                orderedSelection: true,
                selectionLimit: 6,
            });
            // console.log("ImagePicker Result:", result);
            setModalVisible(false);
            
            const userData = await getUserData();
            if (!result?.canceled) {
                if (result.assets?.length > 6) {
                    setTeg(true)
                }

                setUriArray((prev) => [
                    ...prev,
                    ...result.assets
                ])
                for (let j in result.assets) {

                    if (imageArrays.length < 6) {
                        const compressedURI = await compressImage(result.assets[j].uri);
                        const body = {
                            fileName: Math.random().toString(36).substring(2, 12),
                            contentType: result.assets[j].type || "image/jpeg",
                            fileType: "profileImage",
                            fileTypeId: userData?.data?.data?._id,
                            imageURL: compressedURI,
                        };
                        const imageurl = await uploadfunction(body);
                        setimageArrays((previmageArrays) => [
                            ...previmageArrays,
                            imageurl
                        ]);
                    }
                }
                console.log(uriArray)
            }
        } catch (error) {
            console.error("Error picking image:", error);
            // Handle the error appropriately
        }
    };

    const uploadfunction = async (body: any) => {
        try {

            setSelectedImage(body);
            const getURL = await getS3URL(body);
            await putImageInS3URL(getURL?.data?.preSignedUrl, body);
            const uploadedURL = await getImageURL(body);

            return uploadedURL?.data?.url
        } catch (error) {
            console.error("Error uploading image:", error);
            // Handle the error appropriately
            setLoading(false);
            throw error; // Rethrow the error if necessary
        }
    };
    const compressImage = async (uri: any) => {
        // console.log("Compressing image");

        try {
            const manipResult = await ImageManipulator.manipulateAsync(
                uri,
                [{ resize: { height: 1100 } }],
                { compress: 0.8, format: ImageManipulator.SaveFormat.JPEG }
            );
            return manipResult.uri;
        } catch (error) {
            console.error("Error compressing image:", error);
            return uri; // Return original URI if compression fails
        }
    };

    const handleSubmitButton = async () => {
        setTeg(false)
        // let photoArray: string[] = [];

        // setLoading(true);
        // for (let i = 0; i < imageArrays.length; i++) {
        //     const compressedURI = await compressImage(imageArrays[i].uri); // Compress image before uploadin        
        //     const body = {
        //         fileName: Math.random().toString(36).substring(2, 12),
        //         contentType: imageArrays[i]?.type || "image/jpeg",
        //         fileType: "profileImage",
        //         fileTypeId: userData?.data?.data?._id,
        //         imageURL: compressedURI,
        //     };
        //     const imageurl = await uploadfunction(body);
        //     if (imageurl != null) {
        //         photoArray.push(imageurl);
        //     }
        // }
        const updateUser = {
            photos: imageArrays,
            steps: 4,
        };

        if (!imageArrays.length) {
            Alert.alert("Please upload at least 1 photos");
            setLoading(false);
        } else {
            const response = await updateDataImage(updateUser);
            await updateData(updateUser);
            // console.log(response);
            setLoading(false);
            navigation.navigate(PROFILE_ROUTES.SELECT_EXPERIENCE as never);
        }
    }


    const toggleModal = () => {
        setModalVisible(!modalVisible);
    };

    return (
        <SafeAreaView
            style={{
                flex: 1,
                backgroundColor: "#ffffff",
                paddingTop: 30
            }}
        >
            <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
            <OnboardingUploadModal
                isVisible={modalVisible}
                toggleModal={toggleModal}
                onPress={handleUploadGallery}
            />
            <View
                style={{
                    flex: 1,
                    paddingHorizontal: 25,
                    gap: 16
                }}
            >
               
                <View style={{display:'flex',width:'100%',justifyContent:'center',alignItems:'center'}}>
                <TopIconView
                icon={<OnBoardingIcons.GalleryIcon />}
                currentScreen={4}
                totalScreens={10}
          /></View>
                <View>
                    <TextView
                        title="Pick your profile photos"
                        textStyle={[
                            GlobalStyles.heading3SemiBold,
                            {
                                fontSize: 34,
                                lineHeight: 37,
                                letterSpacing: -0.3
                            },
                        ]}
                    />
                    <TextView
                        title="Add at least one photo"
                        textStyle={[GlobalStyles.bodyText, {
                            fontFamily: "EBGaramondMedium",
                            fontSize: 16,
                            lineHeight: 20,
                            letterSpacing: -0.3,
                            color: "#000000",
                            opacity: 0.5,
                        }]}
                        boxStyle={{ marginTop: 8 }}
                    />
                    {loading === true ? (
                        <>
                            <ActivityIndicator size="large" />
                        </>
                    ) : (
                        <>
                            <View style={styles.mainImageBox}>
                                <View style={styles.uploadBoxMain}>
                                    <View style={styles.innerUploadMain}>
                                        {imageArrays[0] == undefined ? (uriArray[0] != undefined ? <>
                                            <View>
                                                <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: uriArray[0].uri }}
                                                />
                                            </View >
                                        </> :
                                            <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                <View style={styles.imageBox}>
                                                    <OnBoardingIcons.PickIcon />
                                                </View>
                                            </TouchableOpacity>

                                        ) : (
                                            <View>
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: imageArrays[0] }}
                                                />
                                                <TouchableOpacity
                                                    style={styles.cancleButtonBox}
                                                    onPress={() => {
                                                        setimageArrays(
                                                            imageArrays.filter((a) => a !== imageArrays[0])
                                                        );
                                                        setUriArray(
                                                            uriArray.filter((a) => a !== uriArray[0])
                                                        )
                                                    }}
                                                >
                                                    <OnBoardingIcons.ReUploadIconv2 />
                                                </TouchableOpacity>
                                            </View>
                                        )}
                                        {imageArrays[1] == undefined ? (uriArray[1] != undefined ? <>
                                            <View>
                                                <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: uriArray[1].uri }}
                                                />
                                            </View >
                                        </> :
                                            <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                <View style={styles.imageBox}>
                                                    <OnBoardingIcons.PickIcon />
                                                </View>
                                            </TouchableOpacity>

                                        ) : (
                                            <View>
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: imageArrays[1] }}
                                                />
                                                <TouchableOpacity
                                                    style={styles.cancleButtonBox}
                                                    onPress={() => {
                                                        setimageArrays(
                                                            imageArrays.filter((a) => a !== imageArrays[1])
                                                        );
                                                        setUriArray(
                                                            uriArray.filter((a) => a !== uriArray[1])
                                                        )
                                                    }}
                                                >
                                                    <OnBoardingIcons.ReUploadIconv2 />
                                                </TouchableOpacity>
                                            </View>
                                        )}
                                        {imageArrays[2] == undefined ? (uriArray[2] != undefined ? <>
                                            <View>
                                                <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: uriArray[2].uri }}
                                                />
                                            </View >
                                        </> :
                                            <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                <View style={styles.imageBox}>
                                                    <OnBoardingIcons.PickIcon />
                                                </View>
                                            </TouchableOpacity>

                                        ) : (
                                            <View>
                                                <Image
                                                    style={{ height: 100, width: 100 }}
                                                    source={{ uri: imageArrays[2] }}
                                                />
                                                <TouchableOpacity
                                                    style={styles.cancleButtonBox}
                                                    onPress={() => {
                                                        setimageArrays(
                                                            imageArrays.filter((a) => a !== imageArrays[2])
                                                        );
                                                        setUriArray(
                                                            uriArray.filter((a) => a !== uriArray[2])
                                                        )
                                                    }}
                                                >
                                                    <OnBoardingIcons.ReUploadIconv2 />
                                                </TouchableOpacity>
                                            </View>
                                        )}
                                    </View>
                                    <View style={styles.uploadBoxMain}>
                                        <View style={styles.innerUploadMain}>
                                            {imageArrays[3] == undefined ? (uriArray[3] != undefined ? <>
                                                <View>
                                                    <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: uriArray[3].uri }}
                                                    />
                                                </View >
                                            </> :
                                                <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                    <View style={styles.imageBox}>
                                                        <OnBoardingIcons.PickIcon />
                                                    </View>
                                                </TouchableOpacity>

                                            ) : (
                                                <View>
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: imageArrays[3] }}
                                                    />
                                                    <TouchableOpacity
                                                        style={styles.cancleButtonBox}
                                                        onPress={() => {
                                                            setimageArrays(
                                                                imageArrays.filter((a) => a !== imageArrays[3])
                                                            );
                                                            setUriArray(
                                                                uriArray.filter((a) => a !== uriArray[3])
                                                            )
                                                        }}
                                                    >
                                                        <OnBoardingIcons.ReUploadIconv2 />
                                                    </TouchableOpacity>
                                                </View>
                                            )}
                                            {imageArrays[4] == undefined ? (uriArray[4] != undefined ? <>
                                                <View>
                                                    <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: uriArray[4].uri }}
                                                    />
                                                </View >
                                            </> :
                                                <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                    <View style={styles.imageBox}>
                                                        <OnBoardingIcons.PickIcon />
                                                    </View>
                                                </TouchableOpacity>

                                            ) : (
                                                <View>
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: imageArrays[4] }}
                                                    />
                                                    <TouchableOpacity
                                                        style={styles.cancleButtonBox}
                                                        onPress={() => {
                                                            setimageArrays(
                                                                imageArrays.filter((a) => a !== imageArrays[4])
                                                            );
                                                            setUriArray(
                                                                uriArray.filter((a) => a !== uriArray[4])
                                                            )
                                                        }}
                                                    >
                                                        <OnBoardingIcons.ReUploadIconv2 />
                                                    </TouchableOpacity>
                                                </View>
                                            )}
                                            {imageArrays[5] == undefined ? (uriArray[5] != undefined ? <>
                                                <View>
                                                    <ActivityIndicator size="large" style={{ position: 'absolute', top: 30, left: 30, zIndex: 123 }} />
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: uriArray[5].uri }}
                                                    />
                                                </View >
                                            </> :
                                                <TouchableOpacity onPress={() => setModalVisible(true)}>
                                                    <View style={styles.imageBox}>
                                                        <OnBoardingIcons.PickIcon />
                                                    </View>
                                                </TouchableOpacity>

                                            ) : (
                                                <View>
                                                    <Image
                                                        style={{ height: 100, width: 100 }}
                                                        source={{ uri: imageArrays[5] }}
                                                    />
                                                    <TouchableOpacity
                                                        style={styles.cancleButtonBox}
                                                        onPress={() => {
                                                            setimageArrays(
                                                                imageArrays.filter((a) => a !== imageArrays[5])
                                                            );
                                                            setUriArray(
                                                                uriArray.filter((a) => a !== uriArray[5])
                                                            )
                                                        }}
                                                    >
                                                        <OnBoardingIcons.ReUploadIconv2 />
                                                    </TouchableOpacity>
                                                </View>
                                            )}
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </>
                    )}
                </View>
                {teg && <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <View style={{ backgroundColor: '#f5e8ce66', borderWidth: 1, borderColor: '#F5B63A', paddingHorizontal: 26, paddingVertical: 14, borderRadius: 6 }}><Text style={{ color: "#F5B63A" }}> ⚠️ Only 6 got selected </Text></View>
                </View>}
            </View>
            <BottomView
                enableTitle={false}
                onPress={handleSubmitButton}
                disableBtn={imageArrays.length > 0 ? true : false}
                style={{ paddingBottom: 20 }}
            />
        </SafeAreaView>
    );
}

export default UploadProfie;